webpackJsonp([14],{

/***/ 1914:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1936),
  /* template */
  __webpack_require__(1986),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1936:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_leiloes_services_lote_debito__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_mask__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_money__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PopupViewer: __WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer___default.a,
    NovoTipoLoteDebito: function NovoTipoLoteDebito() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1970));
    }
  },
  directives: { mask: __WEBPACK_IMPORTED_MODULE_4_v_mask__["a" /* VueMaskDirective */], money: __WEBPACK_IMPORTED_MODULE_6_v_money__["VMoney"] },
  nome: 'novo-lote-debito',
  props: {
    debitoId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      money: __WEBPACK_IMPORTED_MODULE_5__utils_helpers_money__["a" /* REAL_BRL */],
      isLoading: false,
      isLoaded: false,
      cadastroError: null,
      atualizadoSucesso: null,
      data: {
        descricao: null,
        valor: null,
        tipo: null,
        ordem: null
      },
      tiposDebito: [],
      showTipoDebitoForm: false
    };
  },

  computed: {
    valorDebitoFloat: function valorDebitoFloat() {
      if (!this.data.valor) {
        return;
      }
      var convertMoneyToFloat = function convertMoneyToFloat(str) {
        return +str.replace(/^\D*/, '').replace(/\./, '').replace(/,/, '.');
      };
      return convertMoneyToFloat(this.data.valor);
    }
  },
  created: function created() {
    this.carregarTiposDebito();
  },
  mounted: function mounted() {
    this.start();
  },
  activated: function activated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    start: function start() {
      var _this = this;

      if (this.debitoId) {
        this.$parent.loading(true);
        __WEBPACK_IMPORTED_MODULE_2__domain_leiloes_services_lote_debito__["a" /* default */].findDebitoLote(this.debitoId).then(function (response) {
          _this.isLoaded = true;
          _this.data = response.data;
          _this.data.tipo = _this.data.tipo.id;
        }).catch(function (response) {
          console.log(response);
        }).finally(function () {
          _this.$parent.loading(false);
        });
      } else {
        this.isLoaded = true;
      }
    },
    submit: function submit() {
      var _this2 = this;

      this.cadastroError = null;
      this.atualizadoSucesso = false;
      this.$bar.start();
      this.$parent.loading(true);
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
      data.valor = this.valorDebitoFloat;
      __WEBPACK_IMPORTED_MODULE_2__domain_leiloes_services_lote_debito__["a" /* default */].cadastroDebitoLote(data, this.$route.params.id, this.debitoId).then(function (response) {
        var callbackEnd = function callbackEnd() {
          _this2.$bar.finish();
          if (_this2.$route.params.id) {
            _this2.start();
            _this2.atualizadoSucesso = true;
            _this2.$el.querySelector('#sucessMsg').focus();
          } else {
            _this2.atualizadoSucesso = true;
          }
          _this2.$emit('finishSubmit');
        };
        callbackEnd();
      }).catch(function (response) {
        _this2.$bar.finish();
        _this2.cadastroError = response.data.errors;
        _this2.$nextTick(function () {
          _this2.$refs.error.focus();
        });
        console.log(response);
      }).finally(function () {
        _this2.$parent.loading(false);
      });
    },
    carregarTiposDebito: function carregarTiposDebito() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__domain_leiloes_services_lote_debito__["a" /* default */].listAllTipoDebito().then(function (response) {
        _this3.tiposDebito = response.data;
      }).catch(function (error) {
        _this3.cadastroError = error.data.errors;
      });
    },
    openTipoDebitoForm: function openTipoDebitoForm() {
      this.showTipoDebitoForm = true;
    },
    closeTipoDebitoForm: function closeTipoDebitoForm() {
      this.showTipoDebitoForm = false;
    },
    finishSubmitCadastroTipoDebito: function finishSubmitCadastroTipoDebito() {
      this.closeTipoDebitoForm();
      this.carregarTiposDebito();
    },
    printError: function printError(err) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"])(err)) {
        return err[0];
      }
      return err;
    }
  }
});

/***/ }),

/***/ 1986:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Gerenciamento de Débitos")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.descricao),
      expression: "data.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "descricao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.valor),
      expression: "data.valor"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "valor", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tipo),
      expression: "data.tipo"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposDebito), function(tipo) {
    return _c('option', {
      key: tipo.id,
      domProps: {
        "value": tipo.id
      }
    }, [_vm._v(_vm._s(tipo.nome))])
  })], 2), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-xs pull-right m-t-sm m-b-xs m-r-xs btn-default",
    on: {
      "click": _vm.openTipoDebitoForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cadastrar tipo de débito\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Ordem")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ordem),
      expression: "data.ordem"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.ordem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "ordem", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    attrs: {
      "type": "submit"
    }
  }, [(!_vm.data.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancelar")])], 1)])])])]), _vm._v(" "), (_vm.showTipoDebitoForm) ? _c('popup-viewer', {
    attrs: {
      "title": "Cadastro de Tipo de Debito"
    },
    on: {
      "close": _vm.closeTipoDebitoForm
    }
  }, [_c('NovoTipoLoteDebito', {
    on: {
      "cancel": _vm.closeTipoDebitoForm,
      "finishSubmit": _vm.finishSubmitCadastroTipoDebito
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.881e79b53c53d36a9b7b.js